import React from 'react';

import { Avatar, makeStyles } from '@material-ui/core';
import portal from '../media/images/whirl.png';


const useStyles = makeStyles((theme)=>({
    large: {
        width: '10vh',
        height: '10vh',
      },
      room : {
          width : '5vw',
          height : '5vw',
      },
      roomMob : {
        width : '15vw',
        height : '15vw',
    }
}))

export default function Logo(props) {

    const classes = useStyles();
    var longPress;

    var handleClickEvent = (e) => {
        console.log("Clicked Logo",e)
        var isLeftMB;
        if ("which" in e)  // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
            isLeftMB = e.which == 0; 
        else if ("button" in e)  // IE, Opera 
            isLeftMB = e.button == 0;
        if(isLeftMB){
            document.getElementById('EasterEgg').click();
        }
     
    }
    var handleStartClick = (e) => {
        if(props.view === 'mobile') {
            longPress = window.setTimeout(() => { 
                props.longPress()
            },1000);
        }
    }

    var handleLongClick = (e) => {
        if(props.view === 'mobile'){
            clearTimeout(longPress);
        }
        return false;
    }

    if(props.from && props.from === "room") {
        if(props.view && props.view === 'mobile') {
            return(
                <Avatar onClick={props.handleClick} alt="Teleport Logo" src={portal} className={classes.roomMob}  />
            )    
        }
        return(
            <Avatar onClick={props.handleClick} alt="Teleport Logo" src={portal} className={classes.room}  />
        )
    }

    return(
        <>
            <Avatar id="telIcon" onTouchEnd={(e)=>{handleLongClick(e)}} onTouchStart={(e)=>{handleStartClick(e)}} onMouseDown={(e) =>{ handleClickEvent(e); }}  alt="Teleport Logo" src={portal} className={classes.large}  />
            <input multiple type="file" id="EasterEgg" style={{display:'none'}}  name="Easter Egg Add Files" />
        </>
    )

}